/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    active: PropTypes.bool,
};

const defaultProps = {
    ...commonDefaultProps,
    active: false,
};

const TabItem = (props) => {
    const classNames = [
        'c-tab__item',
        props.active ? 'is-active' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

TabItem.propTypes = propTypes;

TabItem.defaultProps = defaultProps;

export default TabItem;
